import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import deliveryCompanyRemote from '../../../api/deliveryCompanyRemote';

import DeliveryCompany from '../../../models/DeliveryCompany';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';

import TruckingCompanyModal from './truckingCompanyModal/TruckingCompanyModal';
import TruckingCompanyDropDown from '../../common/CompanyDropDown';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';

import InfoIcon from '@material-ui/icons/Info';
import style from '../../common/commonComponentsStyle.module.css';

import validation from '../../../utils/validation';

const PREFIX_PHONE_NUMBER: string = '+1';

interface TruckingCompanyContainerProps {
  receiveError: Function;
  setDeliveryCompanyID: Function;
  selectedDeliveryCompanyID: number | undefined;
  showDetails: boolean;
  hideTruckerInfo: Function;
  resetPickupTime: Function;
  changedDeliveryCompany: Function;
  initialDeliveryCompanyID: number | undefined;
  poDeliveryCompanyID:  number | undefined;
  allowedToChangeTruckingCompany: boolean;
};

interface TruckingCompanyContainerState {
  deliveryCompanies: Array<DeliveryCompany>;
  name: string;
  email: string;
  phoneNumber: string;
  deliveryCompanyValue: number | undefined;
  modalOpen: boolean;
  isPhoneNumber: boolean;
  isEmail: boolean;
  isValidName: boolean;
  errorName: string;
  isConfirmationOpen: boolean;
  deliveryCompanyID: number;
  action: string;
};

class TruckingCompanyContainer extends Component<TruckingCompanyContainerProps, TruckingCompanyContainerState> { 

  state = {
    deliveryCompanies: [],
    name: '',
    email: '',
    phoneNumber: '',
    modalOpen: false,
    isPhoneNumber: true,
    isEmail: true,
    isValidName: true,
    errorName: 'the name can not be empty',
    deliveryCompanyValue: undefined,
    isConfirmationOpen: false,
    deliveryCompanyID: -1,
    action: ''
  };

  componentDidMount() {

    this.setState({ deliveryCompanyValue: this.props.selectedDeliveryCompanyID });

    deliveryCompanyRemote.getDeliveryCompanies().then((resp: ApiResponse<Array<DeliveryCompany>>) => {

      const deliveryCompanies: Array<DeliveryCompany> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (deliveryCompanies) {
        this.setState({ deliveryCompanies });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  componentDidUpdate(prevProps: TruckingCompanyContainerProps) {

    if (prevProps.selectedDeliveryCompanyID !== this.props.selectedDeliveryCompanyID) {
      this.setState({ deliveryCompanyValue: this.props.selectedDeliveryCompanyID });
    }
  }

  handleOpenModal = (): void => {

    if (this.props.initialDeliveryCompanyID !== null && this.props.selectedDeliveryCompanyID ) {
      this.setState({ action: 'handleOpenModal', isConfirmationOpen: true });
    } else {
      this.setState({ modalOpen: true });
    }
  };

  handleCloseModal = (): void => {
    this.setState({
      name: '',
      email: '',
      phoneNumber: '',
      modalOpen: false,
      isPhoneNumber: true,
      isEmail: true,
      isValidName: true,
      errorName: 'the name can not be empty'
    });
  };

  onValidationName = (): void => {

    if (this.state.name === '') {
      this.setState({
        isValidName: false,
        errorName: 'the name can not be empty'
      });
    } else {

      const isNameExist: boolean = this.state.deliveryCompanies.some((item: DeliveryCompany) => item.name === this.state.name);

      if (isNameExist) {
        this.setState({
          isValidName: false,
          errorName: 'the name exist'
        });
      } else {
        this.setState({
          isValidName: true,
          errorName: ''
        });
      };
    };
  };

  onValidationEmail = (): void => {

    if (this.state.email !== '') {

      const isEmail: boolean = validation.validateEmail(this.state.email);
      
      this.setState({ isEmail })
    } else {
      this.setState({ isEmail: true });
    };
  };

  onValidationPhoneNumber = (): void => {

    if (this.state.phoneNumber !== '') {
  
      const isPhoneNumber: boolean = validation.validatePhoneNumber(this.state.phoneNumber);

      this.setState({ isPhoneNumber });
    } else {
      this.setState({ isPhoneNumber: true });
    };
  };

  handleChange = (propertyName: string, event: any)  => {

    const value: string = event.target.value;

    switch (propertyName) {
      case 'name': 
        this.setState({ name: value }); 
        break;
      case 'email': 
        this.setState({ email: value }); 
        break;
      case 'phoneNumber':
       this.setState({ phoneNumber: value }); 
       break;
      default: return;
    };
  };

  handleSubmit = (): void => {

    const phoneNumber: string = this.state.phoneNumber;
    const newDeliveryCompany: DeliveryCompany = {
      name: this.state.name.trim(),
      owned: false,
      default_email: this.state.email,
      default_sms : (phoneNumber ? PREFIX_PHONE_NUMBER : '') + phoneNumber
    };

    deliveryCompanyRemote.addNewDeliveryCompany(newDeliveryCompany).then((resp: ApiResponse<Array<DeliveryCompany>>) => {

      const deliveryCompanies: Array<DeliveryCompany> | undefined = resp.result;
      const error: ResponseError| undefined = resp.error;

      if (deliveryCompanies) {

        const deliveryCompany : DeliveryCompany | undefined = deliveryCompanies.find(x=> x.name === this.state.name);

        if (deliveryCompany) {

          const deliveryCompanyValue: number | undefined = deliveryCompany.id;

          this.setState({ deliveryCompanyValue });
          this.props.setDeliveryCompanyID(deliveryCompanyValue);
        };
        
        this.setState({ deliveryCompanies });
        this.handleCloseModal();
      };

      if (error) {
        this.props.receiveError(error);
      }; 
    });
  };

  handleChangeDeliveryCompany = (event: any): void => { 

    const deliveryCompanyValue: number = Number(this.state.deliveryCompanyID);

    this.props.changedDeliveryCompany(deliveryCompanyValue);
    this.setState({ deliveryCompanyValue });
  };

  openConfirmation = (event: any): void => {

    const companyId: number = Number(event.value);

    this.setState({ action: 'openConfirmation', deliveryCompanyID: companyId });

    if (this.props.poDeliveryCompanyID !== null && this.props.initialDeliveryCompanyID !== companyId) {

      this.setState({ isConfirmationOpen: true });
    }
    else {

      this.setState({ deliveryCompanyValue: companyId });
      this.props.changedDeliveryCompany(companyId);
    }
  }

  closeConfirmation = (): void => {

    this.setState({ isConfirmationOpen: false });
  }

  switchToAction = (): void => {

    const action: string = this.state.action;

    switch (action) {

      case 'openConfirmation': this.handleChangeDeliveryCompany(null); break;
      case 'handleOpenModal': this.setState({ modalOpen: true }); break;
      default: break;
    }

    this.props.resetPickupTime();
    this.closeConfirmation();
  }

  render() {
    return (
      <Fragment>
        <div className={ style.dropDownTruckSelectWrapper }>
          <div className={ style.info }><InfoIcon color="primary" className={ style.materialIcon } />Select Trucking company or create new using "+"</div>
          <TruckingCompanyDropDown 
            openModal={ this.handleOpenModal }
            items={ this.state.deliveryCompanies }
            value={ this.state.deliveryCompanyValue }
            onChange={ this.openConfirmation }
            allowedToChange={ this.props.allowedToChangeTruckingCompany }
            labelText=''
            type="truckingCompany"
          />
        </div>
        
        { this.state.modalOpen && 
          <TruckingCompanyModal
            name={ this.state.name }
            email={ this.state.email }
            phoneNumber={ this.state.phoneNumber }
            modalOpen={ this.state.modalOpen }
            prefixPhoneNumber={ PREFIX_PHONE_NUMBER }
            isPhoneNumber={ this.state.isPhoneNumber }
            isEmail={ this.state.isEmail }
            isValidName={ this.state.isValidName }
            errorName={ this.state.errorName }
            handleCloseModal={ this.handleCloseModal }
            onValidationName={ this.onValidationName }
            onValidationEmail={ this.onValidationEmail }
            onValidationPhoneNumber={ this.onValidationPhoneNumber }
            handleChange={ this.handleChange }
            handleSubmit={ this.handleSubmit }
          />
        }
        { this.state.isConfirmationOpen &&
          <ConfirmationDialog
            open={ this.state.isConfirmationOpen }
            close={ this.closeConfirmation }
            title='Trucking Company Change Confirmation'
            text='If you change the Trucking company you will lose any available data for the previously selected Trucking company, the driver, contacts and notifications send. To confirm use “OK”. To cancel use “X”.'
            textConfirm='OK'
            confirm={ this.switchToAction }
            showCloseIcon={ true }
          />
        }
      </Fragment>
    );
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(null, mapDispatchToProps)(TruckingCompanyContainer);
